import React from 'react';
import useStyles from './ReferralLink.styles';
import {DEFAULT_LOCALE} from '@/utils/localization';
import {resolveQueryStrings} from '@/utils/stringUtils/stringUtils';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

type Props = {
  text?: string;
};

const Header = ({text}: Props) => {
  const classes = useStyles();

  const [headerText] = resolveQueryStrings([text], DEFAULT_LOCALE);

  return (
    <ReactMarkdown
      className={classes.sectionHeader}
      rehypePlugins={[rehypeRaw as any]}
      children={headerText || 'Share the gift of reading'}
    />
  );
};

export default Header;
